import api from '../api/api'
import url from '../api/env'

const getChains = async () => 
    api
      .get(`${url.stage.storeChain_options}?paginate=0`, {})
      .then(res => res)
      .catch(err => err) 

export default {
    getChains,
}
